<script setup lang="ts">
import { RouterView } from 'vue-router';
import type { RouteLocationNormalized } from 'vue-router';

// Define transition logic based on route
function getTransitionName(route: RouteLocationNormalized): string {
  if (route.name === 'Login') {
    return 'fade';
  }
  if (route.name === 'Workspace') {
    return 'slide-left';
  }
  if (route.name === 'TicketDetail' || route.name === 'Chat') {
    return 'slide-up';
  }
  return 'fade';
}
</script>

<template>
  <div id="app">
    <RouterView v-slot="{ Component, route }">
      <Transition
        :name="getTransitionName(route)"
        mode="out-in"
        appear
      >
        <component :is="Component" :key="route.path" />
      </Transition>
    </RouterView>
  </div>
</template>

<style>
#app {
  min-height: 100vh;
  font-family: 'Poppins', 'Roboto', system-ui, sans-serif;
  overflow-x: hidden;
}

/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Slide Left Transition */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}

/* Slide Up Transition */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* Scale Transition */
.scale-enter-active,
.scale-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.scale-enter-from {
  opacity: 0;
  transform: scale(0.95);
}

.scale-leave-to {
  opacity: 0;
  transform: scale(1.05);
}
</style>
